// src/constants/chatTranslationLabels.js
//
// The few words Ask Previu shows around a translated message, in the
// patient's own language. Bundled rather than translated on the fly: they
// must still show when translation itself is what failed.
//
// ml / hi: machine-drafted — NEEDS NATIVE REVIEW before translation is
// switched on for patients.

export const CHAT_TRANSLATION_LABELS = {
  en: {
    translatedByAi: 'Translated by AI',
    seeEnglish: 'See English',
    hideEnglish: 'Hide English',
    seeUnderstood: 'See what Previu understood',
    hideUnderstood: 'Hide what Previu understood',
    pleaseCheck: 'Please check: see English',
    couldNotTranslate: "Couldn't translate this reply",
    cutShort: 'This reply was cut short. Ask me to continue.',
  },
  // needs native review
  ml: {
    translatedByAi: 'AI വിവർത്തനം ചെയ്തത്',
    seeEnglish: 'ഇംഗ്ലീഷിൽ കാണുക',
    hideEnglish: 'ഇംഗ്ലീഷ് മറയ്ക്കുക',
    seeUnderstood: 'Previu മനസ്സിലാക്കിയത് കാണുക',
    hideUnderstood: 'Previu മനസ്സിലാക്കിയത് മറയ്ക്കുക',
    pleaseCheck: 'ദയവായി പരിശോധിക്കുക: ഇംഗ്ലീഷ് കാണുക',
    couldNotTranslate: 'ഈ മറുപടി വിവർത്തനം ചെയ്യാൻ കഴിഞ്ഞില്ല',
    cutShort: 'ഈ മറുപടി പൂർത്തിയായില്ല. തുടരാൻ എന്നോട് ആവശ്യപ്പെടുക.',
  },
  // needs native review
  hi: {
    translatedByAi: 'AI द्वारा अनुवादित',
    seeEnglish: 'अंग्रेज़ी देखें',
    hideEnglish: 'अंग्रेज़ी छिपाएँ',
    seeUnderstood: 'Previu ने क्या समझा, देखें',
    hideUnderstood: 'Previu ने जो समझा, उसे छिपाएँ',
    pleaseCheck: 'कृपया जाँचें: अंग्रेज़ी देखें',
    couldNotTranslate: 'इस जवाब का अनुवाद नहीं हो सका',
    cutShort: 'यह जवाब अधूरा रह गया। आगे जारी रखने के लिए मुझसे कहें।',
  },
};

export function chatTranslationLabels(lang) {
  return CHAT_TRANSLATION_LABELS[lang] || CHAT_TRANSLATION_LABELS.en;
}
